import { useMutation, useQueryClient } from "react-query";

import { authPost } from "@api";

import { useOrg } from "./useOrg";

export type UserInviteRole = "member" | "admin";
type UserInvite = {
  invited_email: string;
  initial_role: UserInviteRole;
};

type Params = {
  user_invite: UserInvite;
};

export const useInvitationMutation = () => {
  const deployment = useOrg();
  const queryClient = useQueryClient();

  return useMutation(
    async ({ user_invite }: Params) => {
      if (!deployment) {
        throw new Error("No org");
      }

      if (!deployment?.organization_id) {
        throw new Error("No parent org ID");
      }

      return authPost<{ user_invite: UserInvite }, {}>(
        `/api/agent/organizations/${deployment?.organization_id}/user_invites`,
        { user_invite }
      );
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["invitations", { org: deployment }]);
      },
    }
  );
};
